import moment from "moment-timezone";
export const DateFormat = (dateValue, dateFormat = 'MM-DD-YYYY') => {
    if (dateValue) {
        return moment.utc(dateValue).format(dateFormat);
    } else {
        return '';
    }
}


export const DateFormatTimeZone = (dateValue, dateFormat = 'MM-DD-YYYY') => {

    if (dateValue) {
        var stillUtc = moment.utc(dateValue).toDate();
        var local = moment(stillUtc).local().format(dateFormat);
        return local;
    } else {
        return '';
    }
}

export const ConvertLocalToUtc = (dateValue, dateFormat = 'YYYY-MM-DD HH:mm:ss') => {

    if (dateValue) {
        
        if(dateValue.match(/\d+/g).length ===3){
            let current_time = moment().format("HH:mm:ss")
            dateValue = moment(`${dateValue+' '+current_time}`).toDate();
        }else{
            //dateValue = new  Date(dateValue); 
            dateValue = moment(`${dateValue}`).toDate();
        }
        let utcdate = moment.utc(moment(dateValue).utc()).format(dateFormat)
        return utcdate;
    } else {
        return '';
    }
}

export const ConvertUtcToLocal = (dateValue,dateFormat = 'YYYY-MM-DD HH:mm:ss') => { 
    let local = '';
    if (dateValue) {
        if(dateValue.match(/\d+/g).length ===3){
            let utc_current_time = moment.utc().format("HH:mm:ss");
            dateValue = moment.utc(`${dateValue+' '+utc_current_time}`).format();
            let stillUtc = moment.utc(dateValue).toDate();
            local = moment(stillUtc).local().format(dateFormat);
        }else{
            //dateValue = new  Date(dateValue); 
            let stillUtc = moment.utc(dateValue).toDate();
            local = moment(stillUtc).local().format(dateFormat);
        }
        
        return local;
    } else {
        return '';
    }
}

export const timeAgo = (date) => {
    
    
    date  = DateFormatTimeZone(date, 'YYYY-MM-DD HH:mm:ss');
    const now = new Date();
    let diffInSeconds = Math.floor((now - new Date(date)) / 1000);
    const intervals = [
        { label: "second", value: 60 },
        { label: "minute", value: 60 },
        { label: "hour", value: 24 },
        { label: "day", value: 30 },
        { label: "month", value: 12 },
        { label: "year", value: Infinity },
    ];

    
    let i = 0;
    while (diffInSeconds >= intervals[i].value) {
        diffInSeconds /= intervals[i].value;
        i++;
    }

    const value = Math.floor(diffInSeconds);
    const label = intervals[i].label + (value !== 1 ? "s" : "");

    return `${value} ${label} ago`;
}


export const mdyToYmd = (dateStr) => {
    let [date, time] = dateStr.split('-');

    console.log('>>>>>>>',date)

    let [month, day, year] = date.split('-');
    let ymdDate = `${year}-${month}-${day} ${time}`;
    
    return ymdDate;
}


